import React from 'react'
import { BasicStatsItem } from '../index.styles';

const ProvisionFullScreen = () => {
  return (
    <BasicStatsItem style={{
      width: '100%',
      height: '100%',
    }}>
      <iframe title="PSD iframe" src="https://app.powerbi.com/view?r=eyJrIjoiNWE2ZTQ3NzEtODJiNi00YTlhLWExOGMtYWVkNjA2OTc5ZTFhIiwidCI6ImU2MjQzNTFhLWViZGItNDUwMi1hNGEzLTRiZWI3OTYxODBlZiIsImMiOjl9" />
    </BasicStatsItem>
  )
}

export default ProvisionFullScreen